import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { AuthService } from '../authentication/auth.service';
import { INTERNAL_ROUTES } from './internal-routes';

const KEY_ALLOWEDROUTES = 'allowed_routes';
const KEY_ITEMS = 'items';
const KEY_ROUTERLINK = 'routerLink';
const ROUTE_HOME = '/home';
const ROUTE_LOGIN = '/login';
const ROUTE_NOPERMISSION = '/no-permission';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private url: string;

  constructor(
    private router: Router,
    private authService: AuthService) {}

  /**
   * @description Verify if route to navigate is in allowed routes of the user.
   * @param state The route to navigate
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.url = state.url;

    return this.userLogged();
  }

  /**
   * @description Check's if user is logged in, otherwise redirects to login.
   * @return {boolean}
   */
  public userLogged(): boolean {
    if (this.authService.isAuthenticated()) {
      if (this.validPath()) {
        return true;
      } else {
        this.router.navigate([ROUTE_NOPERMISSION]);
        return false;
      }
    } else {
      this.router.navigate([ROUTE_LOGIN]);
      return false;
    }
  }

  /**
   * @description Gets all routes availables in localStorage and validate if current Url is available
   * if homeUrl is not in local, home is added and other paths neccesaries according to modules availables
   */
  public validPath(): boolean {
    let pathExists: boolean;
    const routes = [];
    const allowedModules = JSON.parse(localStorage.getItem(KEY_ALLOWEDROUTES));

    for (const module of allowedModules) {
      if (module.hasOwnProperty(KEY_ROUTERLINK)) {
        routes.push('/' + module.routerLink);
      }
      if (module.hasOwnProperty(KEY_ITEMS)) {
        module.items.forEach(route => routes.push('/' + route.routerLink));
      }
      for (const invisibleRoute of INTERNAL_ROUTES) {
        if (invisibleRoute.module === module.icon) {
          for (const path of invisibleRoute.routes) {
            routes.push(path);
          }
        }
      }
    }

    if (!routes.find((path) => path === ROUTE_HOME)) {
      routes.push(ROUTE_HOME);
    }

    for (const singlePath of routes) {
      if (this.url.startsWith(singlePath)) {
        pathExists = true;
      } else {
        pathExists = false;
      }
      if (pathExists) {
        break;
      }
    }

    return pathExists;
  }

}
